var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.assignment.DETAILS !== undefined
    ? _c(
        "div",
        { staticClass: "class-page" },
        [
          _c("ClassPageHeader", {
            attrs: {
              details: _vm.details,
              "current-section": parseInt(_vm.sectionId),
              course: _vm.course,
              menu: _vm.menu,
              "is-class-item-page": true,
              "course-content": "courseContent"
            }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "assignment-bin" }, [
            _c("div", { staticClass: "display-table feedback-page" }, [
              !!_vm.assignment.FEEDBACK.GRADED_BY
                ? _c("div", { staticClass: "display-container" }, [
                    _c("div", { staticClass: "header color-status" }, [
                      _c("div", { staticClass: "float-left" }, [
                        _c("h2", [
                          _vm._v(
                            _vm._s(_vm.$t("MAIN_CONTENT.Feedback.feedback"))
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "score-pill float-right" }, [
                        _vm._v(
                          "\n\t\t\t\t\t\t\t\t\t\t\t" +
                            _vm._s(_vm.$t("MAIN_CONTENT.commonContent.score")) +
                            " \n\t\t\t\t\t\t\t\t\t\t\t"
                        ),
                        _c("strong", [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t\t\t\t\t\t" +
                              _vm._s(
                                _vm.$t(
                                  "MAIN_CONTENT.AssignmentBin.gradeOverPoints",
                                  {
                                    grade: _vm.assignment.DETAILS.GRADE_CODE,
                                    points: _vm.assignment.DETAILS.MAX_POINTS
                                  }
                                )
                              ) +
                              "\n\t\t\t\t\t\t\t\t\t\t\t"
                          )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "sub-header",
                      domProps: {
                        innerHTML: _vm._s(_vm.assignment.FEEDBACK.FEEDBACK_TEXT)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "attached" },
                      [
                        _c("div", { staticClass: "header-attached" }, [
                          _c("h3", [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                _vm._s(
                                  _vm.$t(
                                    "MAIN_CONTENT.AssignmentBin.attachedFiles"
                                  )
                                ) +
                                " \n\t\t\t\t\t\t\t\t\t\t\t"
                            ),
                            _c("span", { staticClass: "pill pill-attached" }, [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\t\t\t\t\t" +
                                  _vm._s(
                                    _vm.assignment.FEEDBACK.ATTACHMENTS.length
                                  ) +
                                  "\n\t\t\t\t\t\t\t\t\t\t\t"
                              )
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.assignment.FEEDBACK.ATTACHMENTS, function(
                          attached
                        ) {
                          return _c(
                            "div",
                            {
                              key: attached.REPORT_ID,
                              staticClass: "attached-file"
                            },
                            [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: attached.ATTACHMENT_URL,
                                    target: "_blank"
                                  }
                                },
                                [
                                  _c("i", {
                                    class:
                                      "fas " +
                                      _vm.fileType(attached.CONTENT_ID),
                                    attrs: { "aria-hidden": "true" }
                                  }),
                                  _vm._v(
                                    " " +
                                      _vm._s(attached.CONTENT_FILENAME) +
                                      "\n\t\t\t\t\t\t\t\t\t\t\t"
                                  ),
                                  _c("aria-new-tab-message", {
                                    attrs: {
                                      message: _vm.$t(
                                        "MAIN_CONTENT.Accessibility.opensInNewTab"
                                      )
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          )
                        })
                      ],
                      2
                    )
                  ])
                : _c("div", { staticClass: "display-container" }, [
                    _vm._v(
                      "\n\t\t\t\t\t\t\t" +
                        _vm._s(
                          _vm.$t("MAIN_CONTENT.Feedback.noFeedbackMessage")
                        ) +
                        "\n\t\t\t\t\t\t"
                    )
                  ]),
              _vm._v(" "),
              _c("div", { staticClass: "back-link" }, [
                _c(
                  "a",
                  {
                    on: {
                      click: function($event) {
                        return _vm.$router.go(-1)
                      }
                    }
                  },
                  [
                    _c("i", {
                      staticClass: "fas fa-caret-left",
                      attrs: { "aria-hidden": "true" }
                    }),
                    _vm._v(
                      " \n\t\t\t\t\t\t\t\t" +
                        _vm._s(_vm.$t("MAIN_CONTENT.commonContent.goBack")) +
                        "\n\t\t\t\t\t\t\t"
                    )
                  ]
                )
              ])
            ])
          ])
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }